var React = require('react');

function IconRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.4273 5.08502L22.2719 11.7635L22.2722 11.7633C22.478 11.8794 22.6086 12.0971 22.6141 12.3342C22.6196 12.5713 22.4995 12.792 22.2993 12.913L10.7788 19.8676C10.7589 19.8796 10.7388 19.8906 10.7182 19.9002C10.5296 19.9882 10.3078 19.9802 10.1221 19.8755C9.91612 19.759 9.78554 19.5414 9.78003 19.3043L9.66317 14.4058L10.9627 13.7993L11.0658 18.1391L20.6431 12.3579L10.7964 6.80594L10.8745 10.0869H10.8772V10.1988L10.8856 10.5534L10.8772 10.5573V11.3681H1.90854C1.55474 11.3681 1.26793 11.0813 1.26793 10.7275C1.26793 10.3737 1.55474 10.0869 1.90855 10.0869H9.56063L9.45575 5.67172C9.45024 5.4346 9.57034 5.2139 9.77061 5.09292C9.97088 4.97193 10.2216 4.96888 10.4273 5.08502Z","fill":"black"}));
}

IconRight.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconRight;

IconRight.default = IconRight;
